import {
  IPalette,
  ITextStyles,
  IFontStyles,
  IButtonStyles,
  ITextFieldStyles,
  IDropdownStyles,
  mergeStyles,
  IStackItemStyles,
  IStackTokens,
  HighContrastSelector
} from '@fluentui/react';

export const separatorStyle = (palette: IPalette): ITextStyles => {
  const style: ITextStyles = {
    root: {
      selectors: {
        '::before': {
          backgroundColor: palette.neutralQuaternaryAlt
        }
      }
    }
  };
  return style;
};

export const titleStylesAccessComponentsClass = (palette: IPalette, fonts: IFontStyles): string => {
  const titleStylesAccessComponentsClass = mergeStyles(
    {
      color: palette.black,
      lineHeight: fonts.xLargePlus.lineHeight
    },
    'ml-1'
  );
  return titleStylesAccessComponentsClass;
};

export const peopleDropdownLineStyle = {
  selectors: {
    '.is-open:hover > .ms-Dropdown-title': {
      borderBottom: 1,
      borderBottomColor: '#00ecd1',
      borderBottomStyle: 'solid'
    },
    '.is-open > .ms-Dropdown-title': {
      borderBottom: 1,
      borderBottomColor: '#00ecd1',
      borderBottomStyle: 'solid'
    }
  }
};

export const settingsAndAccessTitleStyles = (palette: IPalette): ITextStyles => {
  const titleStyles: ITextStyles = {
    root: {
      color: palette.black
    }
  };
  return titleStyles;
};

export const settingsButtonStyles = (palette: IPalette, fonts: IFontStyles, width: string | number): IButtonStyles => {
  const buttonStyles: IButtonStyles = {
    root: {
      fontFamily: fonts.medium.fontFamily,
      fontSize: fonts.medium.fontSize,
      lineHeight: fonts.medium.lineHeight,
      height: 40,
      letterSpacing: '0rem',
      textAlign: 'center',
      width: width
    },
    rootDisabled: {
      backgroundColor: palette.neutralQuaternaryAlt
    }
  };
  return buttonStyles;
};

export const settingsFieldStyles = (
  palette: IPalette,
  fonts: IFontStyles,
  width: string | number
): Partial<ITextFieldStyles> => {
  const settingsFieldStyles: Partial<ITextFieldStyles> = {
    fieldGroup: {
      backgroundColor: palette.neutralLighter,
      borderRadius: 2,
      height: 40,
      width: width,
      borderWidth: 1,
      marginTop: 3,
      borderColor: palette.black,
      borderStyle: 'solid',
      selectors: {
        [HighContrastSelector]: {
          borderWidth: 1,
          borderRadius: 2
        }
      }
    },
    field: {
      color: palette.neutralDark
    },
    wrapper: {
      selectors: {
        label: {
          fontFamily: fonts.mediumPlus.fontFamily,
          color: palette.neutralDark
        }
      }
    }
  };
  return settingsFieldStyles;
};

export const settingsDropdownRoleStyles = (
  palette: IPalette,
  fonts: IFontStyles,
  width: string | number
): Partial<IDropdownStyles> => {
  const settingsDropdownRoleStyles: Partial<IDropdownStyles> = {
    root: { width },
    title: {
      borderWidth: 0,
      borderRadius: 4,
      height: 40,
      width: width,
      paddingTop: 10,
      backgroundColor: palette.neutralLighter,
      fontFamily: fonts.medium.fontFamily,
      fontSize: fonts.medium.fontSize,
      lineHeight: fonts.medium.lineHeight,
      color: palette.black,
      selectors: {
        [HighContrastSelector]: {
          borderWidth: 1,
          borderRadius: 2,
          borderColor: palette.white
        }
      }
    },
    caretDownWrapper: {
      paddingTop: 4,
      paddingRight: 4
    },
    caretDown: {
      color: palette.black
    },
    dropdownItemSelected: {
      backgroundColor: palette.neutralLighter
    }
  };
  return settingsDropdownRoleStyles;
};

export const numericalSpacingStackTokens: IStackTokens = {
  childrenGap: 20
};

export const titleTextWrapperStyle: IStackItemStyles = {
  root: {
    marginTop: 10
  }
};

export const textWrapperStyle: IStackItemStyles = {
  root: {
    maxWidth: 504
  }
};
